import React, { useState } from 'react';
import Button from '~/src/components/Button';
import { css } from 'aphrodite';
import PropTypes from 'prop-types';

import styles from './styles';

const Confirmation = ({
  title,
  message,
  onCancel,

  primaryActionTitle,
  onConfirm,
  secondaryActionTitle,
  onSecondaryConfirm,
  processingText,
  destructive,
}) => {
  const [primaryActionDisabled, setPrimaryActionDisabled] = useState(false);
  const [primaryActionLabel, setPrimaryActionLabel] =
    useState(primaryActionTitle);

  const handleSubmit = () => {
    setPrimaryActionDisabled(true);
    setPrimaryActionLabel(processingText || primaryActionTitle);
    onConfirm();
  };

  return (
    <div className={css(styles.modalContainer)}>
      <h1 className={css(styles.modalTitle)}>{title}</h1>
      <p
        className={css(styles.modalMessage, styles.modalMessageCenterVertical)}
      >
        {message}
      </p>
      <div className={css(styles.modalActions)}>
        <Button cssStyle={styles.buttonAction} onClick={onCancel}>
          Cancel
        </Button>

        {secondaryActionTitle && onSecondaryConfirm && (
          <Button cssStyle={styles.buttonAction} onClick={onSecondaryConfirm}>
            {secondaryActionTitle}
          </Button>
        )}

        <Button
          cssStyle={styles.buttonAction}
          onClick={handleSubmit}
          primary={!destructive}
          alert={destructive}
          disabled={primaryActionDisabled}
        >
          {primaryActionLabel}
        </Button>
      </div>
    </div>
  );
};

Confirmation.propTypes = {
  title: PropTypes.string,
  // A sentence, or richer content such as headed paragraphs.
  message: PropTypes.node,
  primaryActionTitle: PropTypes.string,
  secondaryActionTitle: PropTypes.string,
  destructive: PropTypes.bool,
};

Confirmation.defaultProps = {
  title: 'Confirm',
  message: 'Are you sure?',
  primaryActionTitle: 'Confirm',
  secondaryActionTitle: null,
  destructive: false,
};

export default Confirmation;
